import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=74e949e5&scoped=true&lang=pug&"
import script from "./copy.vue?vue&type=script&lang=ts&"
export * from "./copy.vue?vue&type=script&lang=ts&"
import style0 from "./copy.vue?vue&type=style&index=0&id=74e949e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e949e5",
  null
  
)

export default component.exports